import { Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { LayoutComponent } from './components/layout/layout.component';
import { AuthGuard } from './guards/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
  },
  // Routes that use the LayoutComponent (protected by AuthGuard)
  {
    path: '', // All routes using the layout will start from root
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: DashboardComponent,
      },
      {
        path: 'standard-floor-plan',
        loadComponent: () =>
          import(
            './modules/standard-floor-plan/components/standard-floor-plan-list/standard-floor-plan-list.component'
          ).then(m => m.StandardFloorPlanListComponent),
        // No need for canActivate here, parent route has it
      },
    ],
  },
  // Redirect any unmatched top-level routes to the default (which is the LayoutComponent route)
  {
    path: '**',
    redirectTo: '', // AuthGuard will handle redirect to login if needed
  },
];
